import axios from '../api/BaseURL';
import authHeader from './auth-header';

class serviceTypeAPI {
  // service_type type create
  createServiceType(data) {
    return axios.post('/service_type/add', data, { headers: authHeader() });
  }

  // list
  getList() {
    return axios.get('/service_type/list', { headers: authHeader() });
  }

  // service_type type update

  // service_type type delete
  deleteServiceType(id) {
    return axios.delete('/service_type/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    });
  }

  // change status
  changeStatus(id) {
    return axios.put(
      '/service_type/changeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    );
  }

  // service_type type update
  updateServiceType(data) {
    return axios.put('/service_type/update', data, {
      headers: authHeader(),
    });
  }

  // district list
  districtList() {
    return axios.get('/location/districtList', { headers: authHeader() });
  }

  // details district by ID
  districtDetails(id) {
    return axios.get('/location/getDistrictById/' + id, {
      headers: authHeader(),
    });
  }
}
export default new serviceTypeAPI();
